import React, { useEffect } from "react";
import PaymentDetail from "../components/PaymentDetail";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPaymentData } from "../../redux/slices/paymentSlice";
import { updateCustomerDetail } from "../../redux/slices/customerSlice";
import ErrorTransactionNotFound from "../components/ErrorTransactionNotFound";
import Loading from "../../components/LoadingCustom";
import { isExpiredError, createErrorNavigationState } from "../../utils/paymentLinkErrorHandler";

const FirstForm = () => {
  if(process.env.REACT_APP_DEBUG){
    console.log('ini env: ',process.env.REACT_APP_API_URL);
  }

  const { reffNo } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const uneditable = searchParams.get("uneditable") === "1";

  useEffect(() => {
    const name = searchParams.get("name");
    let phone = searchParams.get("phone");
    const email = searchParams.get("email");

    if (phone) {
      phone = phone.replace(/^\+62/, "0");
      if (phone.startsWith("62") && !phone.startsWith("0")) {
        phone = "0" + phone.substring(2);
      }
    }

    if (name || phone || email) {
      dispatch(updateCustomerDetail({
        ...(name && { fullName: name }),
        ...(phone && { phone }),
        ...(email && { email }),
      }));
    }
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  // Mengambil state dari Redux store, including errorCode
  const { data: paymentData, isLoading, error, errorCode } = useSelector((state) => state.payment);

  useEffect(() => {
    if (reffNo) {
      dispatch(fetchPaymentData(reffNo));
    }
  }, [dispatch, reffNo]);

  // Handle navigation based on error code
  useEffect(() => {
    if (error && errorCode) {
      // If payment link is expired, navigate to expired page
      if (isExpiredError(errorCode)) {
        navigate('/payment-expired', {
          replace: true,
          state: createErrorNavigationState(
            { errorCode, message: error },
            {
              reffNo,
              redirectUrl: paymentData?.redirect_url || null,
            }
          ),
        });
      }
      // For other errors, show generic not found page (handled by return below)
    }
  }, [error, errorCode, navigate, reffNo]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-gray-200 bg-opacity-50 flex justify-center items-center z-50">
        <Loading />
      </div>
    );
  }

  if (error || !paymentData) {
    return <ErrorTransactionNotFound errorCode={errorCode} message={error} />;
  }

  return (
    <PaymentDetail
      merchant_name={paymentData.account.merchant.name}
      account_name={paymentData.account.name}
      title={paymentData.title}
      total_amount={paymentData.total_amount}
      reffNo={paymentData.reff_no}
      include_constumer_detail={paymentData.required_customer_detail}
      status={paymentData.status}
      payment_url={paymentData.payment_url}
      description={`Pembayaran untuk order ${paymentData.reff_no}`}
      items={paymentData.items || []}
      uneditable={uneditable}
    />
  );
};

export default FirstForm;